import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GangamaiLanding from "@/pages/GangamaiLanding";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/7d-parenting-system">
        <Routes>
          <Route path="/" element={<GangamaiLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
